jQuery(function($){

    var searchToggle = document.querySelector('.site-header__search');
    var searchPanel = document.getElementById('header-search');
    if (searchToggle && searchPanel) {
        var searchInput = searchPanel.querySelector('input[name="s"]');
        var searchResults = searchPanel.querySelector('.header-search__results');
        var searchTimer;
        var searchRequest;
        var searchVersion = 0;

        function closeSearch() {
            searchPanel.hidden = true;
            searchToggle.setAttribute('aria-expanded', 'false');
            clearTimeout(searchTimer);
            searchVersion++;
            if (searchRequest) searchRequest.abort();
        }

        searchToggle.addEventListener('click', function() {
            if (!searchPanel.hidden) { closeSearch(); return; }
            searchPanel.hidden = false;
            searchToggle.setAttribute('aria-expanded', 'true');
            searchInput.focus();
            searchInput.dispatchEvent(new Event('input'));
        });
        document.addEventListener('click', function(event) {
            if (!searchPanel.contains(event.target) && !searchToggle.contains(event.target)) closeSearch();
        });
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape' && !searchPanel.hidden) {
                closeSearch();
                searchToggle.focus();
            }
        });
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimer);
            if (searchRequest) searchRequest.abort();
            var version = ++searchVersion;
            var term = searchInput.value.trim();
            searchResults.replaceChildren();
            if (!term) return;
            searchTimer = setTimeout(function() {
                searchResults.textContent = 'Wyszukiwanie…';
                searchRequest = $.getJSON(searchPanel.dataset.endpoint, {
                    action: 'cme_search_suggestions', term: term
                }).done(function(response) {
                    if (version !== searchVersion) return;
                    searchResults.replaceChildren();
                    if (!response.success || !response.data.length) {
                        searchResults.textContent = 'Brak wyników.';
                        return;
                    }
                    response.data.forEach(function(item) {
                        var link = document.createElement('a');
                        link.href = item.link;
                        link.textContent = item.title;
						var type = document.createElement('small');
						type.className = 'header-search__type';
						type.textContent = item.type;
						link.appendChild(type);
                        searchResults.appendChild(link);
                    });
                }).fail(function(xhr, status) {
                    if (status !== 'abort' && version === searchVersion) {
                        searchResults.textContent = 'Nie udało się pobrać wyników. Spróbuj ponownie.';
                    }
                });
            }, 250);
        });
    }


    $('.support-donation').each(function() {
        var form = this;
        var custom = form.querySelector('[name="donation_custom"]');
        var amount = form.querySelector('[name="amount"]');
        var submit = form.querySelector('[type="submit"]');
        var submitting = false;

        // Read defaults in the browser so links also work on cached pages.
        var params = new URLSearchParams(window.location.search);
        var requestedAim = params.get('aim');
        var aim = form.querySelector('[name="desc"]');
        if (requestedAim && aim) {
            Array.from(aim.options).forEach(function(option) {
                if (!option.disabled && option.value === requestedAim) {
                    aim.value = option.value;
                }
            });
        }

        var requestedAmount = params.get('amount');
        if (requestedAmount && /^\d+(?:\.\d{1,2})?$/.test(requestedAmount)) {
            var value = Number(requestedAmount);
            if (value >= Number(custom.min) && value <= Number(custom.max)) {
                var selectedValue = ['50', '100', '200'].includes(String(value)) ? String(value) : 'other';
                form.querySelectorAll('[name="donation_amount"]').forEach(function(radio) {
                    radio.checked = radio.value === selectedValue;
                });
                if (selectedValue === 'other') {
                    custom.value = requestedAmount;
                }
            }
        }

        function updateAmount() {
            var selected = form.querySelector('[name="donation_amount"]:checked');
            var isCustom = selected && selected.value === 'other';
            custom.disabled = !isCustom;
            custom.required = isCustom;
            form.querySelector('.support-donation__custom').hidden = !isCustom;
            var value = isCustom ? custom.valueAsNumber : Number(selected ? selected.value : 0);
            var cents = Math.round(value * 100);
            amount.value = Number.isFinite(cents) && cents >= 100 ? String(cents) : '';
            form.querySelector('[data-donation-total]').textContent = amount.value
                ? new Intl.NumberFormat('pl-PL', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100) + ' zł'
                : 'darowiznę';
        }

        form.addEventListener('change', updateAmount);
        custom.addEventListener('input', updateAmount);
        form.addEventListener('submit', function(event) {
            updateAmount();
            if (submitting || !amount.value || !form.reportValidity()) {
                event.preventDefault();
                return;
            }
            // Generate identifiers at submission time, including on cached pages.
            if (!window.crypto || !window.crypto.getRandomValues) {
                event.preventDefault();
                return;
            }
            ['session_id', 'order_id'].forEach(function(name) {
                var bytes = new Uint8Array(16);
                window.crypto.getRandomValues(bytes);
                form.querySelector('[name="' + name + '"]').value = Array.from(bytes, function(byte) {
                    return byte.toString(16).padStart(2, '0');
                }).join('');
            });
            submitting = true;
            submit.disabled = true;
        });
        window.addEventListener('pageshow', function() {
            submitting = false;
            submit.disabled = false;
        });
        updateAmount();
        submit.disabled = false;
    });

	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
    setPhotoMinHeight();
    faq();
    projectsListFilter();
    testimonialReadMore();
    $(function(){
		loopcounter('myCountdown');
	});

    function testimonialReadMore() {
        $('.testimonial-read-more').on('click', function() {
            var $button = $(this);
            var $article = $button.closest('article');
            var $slider = $button.closest('.testimonials-slider');

            $article.find('.testimonial-text--short').attr('hidden', true);
            $article.find('.testimonial-text--full').removeAttr('hidden');
            $button.attr('hidden', true);
            $slider.trigger('refresh.owl.carousel');
        });
    }

    function projectsListFilter() {
        $('.projects-list').each(function() {
            var $section = $(this);
            var $filters = $section.find('.projects-list__categories nav a');
            var $projects = $section.find('.projects-list__wrapper > a');

            function resetFilter(updateUrl) {
                $filters.removeClass('active');
                $projects.show();

                if (updateUrl && window.history && window.history.replaceState) {
                    window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
                }
            }

            function applyFilter(slug, updateUrl) {
                var $filter = $filters.filter(function() {
                    return ($(this).attr('href') || '').replace('#', '') === slug;
                });

                if (!$filter.length) {
                    resetFilter(false);
                    return;
                }

                $filters.removeClass('active');
                $filter.addClass('active');

                $projects.each(function() {
                    $(this).toggle($(this).hasClass(slug));
                });

                if (updateUrl && window.history && window.history.pushState) {
                    window.history.pushState(null, document.title, '#' + slug);
                }
            }

            $filters.on('click', function(event) {
                event.preventDefault();

                var $filter = $(this);
                var slug = ($filter.attr('href') || '').replace('#', '');

                if ($filter.hasClass('active')) {
                    return;
                }

                applyFilter(slug, true);
            });

            $filters.find('span').on('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                if ($(this).closest('a').hasClass('active')) {
                    resetFilter(true);
                }
            });

            if (window.location.hash) {
                applyFilter(decodeURIComponent(window.location.hash.replace('#', '')), false);
            }
        });
    }

    function faq() {
        $('.faq__question').click(function(event) {
            event.preventDefault();
            var href = $(this).attr('href');

            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.faq__answer'+href).slideUp(300);
                return;
            } else {
                $('.faq__answer').slideUp(300);
                $('.faq__question').removeClass('active');
                $(this).addClass('active');
                $('.faq__answer'+href).slideDown(300);
            }
            
        });
    }

    function setPhotoMinHeight() {
        var windowWidth = $(document).width();
        console.log(windowWidth);
        if (windowWidth > 1000) {
            $('.text-photo').each(function () {
                var $section = $(this);

                var descHeight = $section.find('.text-photo__description').outerHeight();
                var $img = $section.find('.text-photo__photo img');

                $img.css('min-height', descHeight + 'px');
            });

            $('.palette__wrapper').each(function () {
                var $section = $(this);

                var descHeight = $section.find('.palette__wrapper .description').outerHeight();
                var $img = $section.find('.palette__wrapper .photo img');
                console.log(descHeight);
                $img.css('min-height', descHeight + 'px');
            });
        }
    }

	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -100;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1140) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
                
			});
			
			// Dodanie obsługi kliknięcia na rodzicu, aby zatrzymać propagację tylko na linkach
			$('.site-header__navigation .menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
                    
				}
			});

           
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 80) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 250 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.header-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
			singleItem: true,
			navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.5 44C47.5 45.933 45.933 47.5 44 47.5L2 47.5C1.17157 47.5 0.5 46.8284 0.5 46L0.500004 2C0.500004 1.17157 1.17158 0.499996 2 0.499996L44 0.5C45.933 0.5 47.5 2.06701 47.5 4L47.5 44Z" stroke="white"/><path d="M28.666 24L19.3327 24" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.666L19.3333 23.9993L24 19.3327" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H46C46.8284 0.5 47.5 1.17157 47.5 2V46C47.5 46.8284 46.8284 47.5 46 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z" stroke="white"/><path d="M19.334 24H28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.334L28.6667 24.0007L24 28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
			autoplayHoverPause:true
		});

        jQuery('.partners-slider').owlCarousel({
            loop:true,
            margin:32,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            stagePadding: 100,
            navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 44C48 46.2091 46.2091 48 44 48L2 48C0.895432 48 7.8281e-08 47.1046 1.74846e-07 46L4.02145e-06 2C4.11801e-06 0.895427 0.895436 -4.11801e-06 2 -4.02145e-06L44 -3.49691e-07C46.2091 -1.56562e-07 48 1.79086 48 4L48 44Z" fill="#F6F6FB"/><path d="M28.666 24L19.3327 24" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.667L19.3333 24.0003L24 19.3337" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4C0 1.79086 1.79086 0 4 0H46C47.1046 0 48 0.895431 48 2V46C48 47.1046 47.1046 48 46 48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#F6F6FB"/><path d="M19.334 24H28.6673" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.333L28.6667 23.9997L24 28.6663" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                },
                960:{
                items:2,
                },
                1100:{
                items:3,
                },
                1240:{
                items:4,
                },
                1440:{
                    items:5,
                },
                1900:{
                    items:6,
                },
                
            }
        });

        jQuery('.testimonials-slider').owlCarousel({
            loop:true,
            margin:50,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            stagePadding: 0,
            navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 44C48 46.2091 46.2091 48 44 48L2 48C0.895432 48 7.8281e-08 47.1046 1.74846e-07 46L4.02145e-06 2C4.11801e-06 0.895427 0.895436 -4.11801e-06 2 -4.02145e-06L44 -3.49691e-07C46.2091 -1.56562e-07 48 1.79086 48 4L48 44Z" fill="#F6F6FB"/><path d="M28.666 24L19.3327 24" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.667L19.3333 24.0003L24 19.3337" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4C0 1.79086 1.79086 0 4 0H46C47.1046 0 48 0.895431 48 2V46C48 47.1046 47.1046 48 46 48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#F6F6FB"/><path d="M19.334 24H28.6673" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.333L28.6667 23.9997L24 28.6663" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                },
                760:{
                items:2,
                },

                1240:{
                items:3,
                },
               
            }
        });
    }

})
